import React from 'react'
import { useTranslation } from 'react-i18next'
import { useExport } from './_requests/export'
import { useModalData } from '../../../components/modals/ModalsContext'
import Form from '../../../packages/kiti/components/form/form/Form'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import GeneralSection, { getFieldsConfigOptions } from './sections/GeneralSection'
import MultiSelectModalContent from './MultiSelectModalContent'
import { convertFilterToRelativeDates } from '../../../utils/helpers/date'

const ModalContent = () => {
  const { t } = useTranslation('export')
  const fieldsConfigOptions = getFieldsConfigOptions(t)
  const { entity, filter, empty, serviceOrderIds } = useModalData()
  const isMultiSelect =
    (serviceOrderIds && serviceOrderIds.length > 0) || (filter && filter.ids && filter.ids.length > 0)
  const [startExport, { loading, error }] = useExport(entity)

  return (
    <Form
      loading={loading}
      onSubmit={startExport}
      initialState={{
        empty,
        filter: convertFilterToRelativeDates(filter) || {},
        fieldsConfig: fieldsConfigOptions[0],
        entity
      }}
    >
      <Separator weight={2} />
      <MultiSelectModalContent />
      <GeneralSection isMultiSelect={isMultiSelect} />

      <SubmitBar loading={loading} error={error} label={t('generate')} />
    </Form>
  )
}

export default ModalContent
